import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';


const getDiscountEventsDetailsData = async (user, event_status, search, page, page_size) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';
    const mode = localStorage.getItem('mode')
    const params = {
        event_status,
        search,
        mode,
        page,
        page_size
    };
    const config = {
        method: 'get',
        url: `service/accounts_service/v1/accounts/discount/getEvents`,
        headers: {
            Authorization: `Bearer ${accessToken}`,
            user,
        },
        params,
    };

    // Log the full request URL and parameters

    try {
        const response = await axios.request(config);
        console.log("Response Data:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error fetching event details:", error);
        throw error;
    }
};


export default getDiscountEventsDetailsData;
